import { format } from 'date-fns';

export function toDateKey(d: Date): string {
    return format(d, 'yyyy-MM-dd');
}

export function generateRandomVeryLargePositiveInteger(): number {
    return Math.floor(Math.random() * 10000000000000) + 10000000000000;
}